export const GROCERY_STORES = ["coles", "woolworths", "aldi"];

export function isGroceryTransaction(description?: string): boolean {
  const lower = (description ?? "").toLowerCase();
  return GROCERY_STORES.some((store) => lower.includes(store));
}
